/* eslint-disable complexity */
import React, { PureComponent } from 'react'

import { push as routerPush } from 'connected-react-router'
import { array, string, bool, func, number } from 'prop-types'
import { length } from 'ramda'
import { connect } from 'react-redux'

import CatalogList from 'components/CatalogList'
import PageFullWidth from 'components/PageFullWidth'
import Wrapper from 'components/Wrapper'
import BrandSlider from 'containers/BrandSlider'
import preventRenderWhileLoading from 'decorators/preventRenderWhileLoading'
import {
  getErrorsBookmarks,
  getWarningsBookmarks,
  bookmarksCatalogSelector,
  getBookmarks,
  fetch
} from 'redux/modules/bookmarks'
import { setCatalogVisible } from 'redux/modules/catalog'
import { getAccess } from 'redux/modules/personal'
import { sectionsByIdSelector } from 'redux/modules/sections'
import { catalogTypeSelector, bookmarkSelector } from 'redux/modules/settings'

import styles from './CatalogList.scss'

const DEFAULT_COLUMN_COUNT = 3

@preventRenderWhileLoading()
@connect(
  ({ sections, settings, bookmarks: bookmarksStore, personal }) => {
    const bookmark = bookmarkSelector(settings)
    const isBookmark = typeof bookmark !== 'undefined'
    const catalogType = catalogTypeSelector(settings)
    const bookmarksCatalog = bookmarksCatalogSelector(bookmarksStore)
    const bookmarkAccess = getAccess(personal, 'BOOKMARKS')
    const bookmarks = getBookmarks(bookmarksStore)
    const sectionsCatalog = sectionsByIdSelector({
      id: 0,
      catalogType,
      sections,
      bookmark
    })
    return {
      sections:
        bookmarkAccess && !isBookmark
          ? [...bookmarksCatalog, ...sectionsCatalog]
          : sectionsCatalog,
      bookmark,
      isBookmark,
      bookmarks,
      bookmarkAccess,
      errorsBookmarks: getErrorsBookmarks(bookmarksStore),
      warningsBookmarks: getWarningsBookmarks(bookmarksStore)
    }
  },
  {
    push: routerPush,
    setCatalogVisible,
    fetchBookmarks: fetch
  }
)
export default class PageCatalogList extends PureComponent {
  static propTypes = {
    sections: array,
    bookmarks: array,
    isBookmark: bool,
    bookmarkAccess: bool,
    setCatalogVisible: func,
    fetchBookmarks: func,
    warningsBookmarks: string,
    errorsBookmarks: string,
    bookmark: number,
    push: func
  }

  static defaultProps = {
    sections: [],
    setCatalogVisible: () => {},
    push: () => {}
  }

  componentDidMount() {
    const { bookmarks, fetchBookmarks, bookmarkAccess } = this.props
    this.props.setCatalogVisible(false)
    if (bookmarkAccess && length(bookmarks) === 0) {
      fetchBookmarks({})
    }
  }

  render() {
    const {
      sections,
      isBookmark,
      warningsBookmarks,
      errorsBookmarks,
      bookmark,
      push
    } = this.props

    const title = isBookmark ? 'Закладочный каталог' : 'Каталог'
    if (isBookmark && (warningsBookmarks || errorsBookmarks)) {
      return (
        <Wrapper>
          <h3>{warningsBookmarks || errorsBookmarks}</h3>
        </Wrapper>
      )
    }
    return (
      <PageFullWidth title={title}>
        <div className={styles.contentWrapper}>
          <div className={styles.catalogList}>
            <CatalogList
              catalogArray={sections}
              columnCount={DEFAULT_COLUMN_COUNT}
              bookmark={bookmark}
              isBookmark={isBookmark}
              push={push}
              isPageCatalog
            />
          </div>

          <div className={styles.sliderWrapper}>
            <BrandSlider page='catalogList' />
          </div>
        </div>
      </PageFullWidth>
    )
  }
}
